<template>
  <div class="container">
    <div @click="showWhy = !showWhy" class="link pointer">
      Why should I sign up?
    </div>
    <div v-if="showWhy" class="why">
      <h5>
        First things first!
        <span @click="showWhy = !showWhy" class="hide pointer">X</span>
      </h5>
      <p>
        We need you to create an account in order to associate this RUX with
        its owner.
      </p>
      <p>
        This will unlock a whole bunch of awesomeness, including our RUX tracking app
        which allows you to upload images of your gear, adding items to packing lists, and
        tracking your gear wherever it is stashed.
      </p>
      <p>
        It will also allow you to register your RUX for warranty and get members
        only pricing on future RUX purchases!
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhySignUp',
  data: function () {
    return {
      showWhy: false,
    }
  },
}
</script>

<style lang='scss' scoped>
.link {
  font-size: larger;
  text-decoration: underline;
}
.hide {
  float: right;
  margin-right: 5px;
  font-size: 1rem;
}
.why {
  background-color: $ruxBeige;
  border-radius: 8px;
  padding: 24px;
  margin-top: 10px;
}
</style>